import React, {Fragment, PureComponent} from 'react';
import './modal.css'

class ComboBox extends PureComponent {
    handleChange = (event) => {
        this.setState({value: event.target.value});
        this.props.onChange(event);
    };

    render() {
        const {comboStyle, comboValue, items} = this.props;
        return (
            <Fragment>
                <select onChange={this.handleChange} value={comboValue} id="Combobox1" style={comboStyle}>
                    {items.values.map(item => (
                        <option key={item.value} value={item.value}>
                            {item.name}
                        </option>
                    ))}
                </select>
            </Fragment>
        );
    }
}

export default ComboBox;